import React from "react";
import { Table } from "../../../../components/atoms";
import {
  hallmarkDataPreparation,
  getHallmarkTable,
  getTableRowsToRender,
} from "./helpers";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import { CancerGeneCensusType } from "../../../../components/componentTypes/CancerGeneCensusType";
import { tableHeaders } from "./constants";

const CancerGeneCensus = ({ data }) => {
  if (data && Object.keys(data || {}).length > 0) {
    const { hallmark_data: hallMarkData } = data;
    let hallmarkData = null;
    let hallmarkTable = null;
    if (hallMarkData) {
      hallmarkData = hallmarkDataPreparation(hallMarkData);
      hallmarkTable = getHallmarkTable(hallmarkData);
    }
    const tableRows = getTableRowsToRender(data);
    const content = (
      <div className="varsome-inner-container" data-testid="cgc-component">
        <div className="tw-overflow-y-auto tw-ml-0 tw-mb-8">
          <Table headers={tableHeaders} rows={tableRows} />
        </div>
        {hallmarkData && (
          <React.Fragment>
            <h5>Hallmark data</h5>
            {hallmarkTable}
          </React.Fragment>
        )}
      </div>
    );
    return (
      <div className="varsome-result-fixed" id="cgc">
        <div className="varsome-container varsome-container__basic">
          <ComponentPanel
            version={data?.version}
            url="https://cancer.sanger.ac.uk/census"
            content={content}
            title="CGC"
          />
        </div>
      </div>
    );
  }

  return null;
};

CancerGeneCensus.propTypes = {
  data: CancerGeneCensusType,
};

CancerGeneCensus.defaultProps = {
  data: null,
};

export default withErrorGuard(CancerGeneCensus, "CancerGeneCensus", "CGC");
